import { Component, OnInit, ViewChildren, ViewChild, Input } from '@angular/core';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import { ForgotComponent } from '../forgot/forgot.component';

@Component({
  selector: 'app-forgot-email',
  templateUrl: './forgot-email.component.html',
  styleUrls: ['./forgot-email.component.css']
})
export class ForgotEmailComponent implements OnInit {

  public mobile_num: any;
  click: boolean = false;
  changePwd: boolean = false;
  public cnfPswd: any;
  public newPswd: any;
  codeDropdown: any = ['+91', '+1'];
  public country: any;

  // formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  // @ViewChildren('formRow') rows: any;

  @ViewChild(ForgotComponent, {static: false}) got: ForgotComponent;
  form: FormGroup;
  mobile_readonly: any;
  code_readonly:any;

  constructor(public usr: UserService,
    public router: Router,
    public toastr: ToastrService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    console.log('Hello ', this.got); 
    // this.got.otp();
  }

  submitForgot(a?:any) {

    if(!this.country){
      return this.toastr.error("Country Code required");
    }else if(!this.mobile_num){
      return this.toastr.error("Mobile Number required ");
    }else {
    let obj = { 
      'mobile_num': this.mobile_num,
      "countrycode":this.country
     };
     console.log(obj);
    let Email = JSON.stringify(this.mobile_num);
    localStorage.setItem('email',Email);
    this.usr.forgotPassword(obj).subscribe((res: any) => {
      console.log(obj);
      if (res.code === 200) {
        if(a!="resend"){
          this.click = !this.click;
        }
        this.changePwd = !this.changePwd;
        this.mobile_readonly=res.data;
        this.code_readonly=res.data;
        this.toastr.success(res.data);
      }
      else {
        this.toastr.error(res.message);
      }
    },
      (err) => {
        console.log(err);
      }
    );
  }
  }
  // @@@@@@@@@@@@@@@@

  loginClose()
  {
    setTimeout(() => {
      this.router.navigate(['login']);
    }, 100);
  }
}
